/**
 * Generates a unique alphanumeric ID using the Crypto Web API.
 * @param maxLength Maximum length of the generated ID.
 * @returns Unique alphanumeric ID.
 */
export function generateUniqueId(maxLength: number = 9): string {
  // Create an array to store random bytes
  const randomBytes = new Uint8Array(maxLength);

  // Generate cryptographically secure random values
  crypto.getRandomValues(randomBytes);

  // Convert random bytes to base 36 (alphanumeric) string
  const id = Array.from(randomBytes)
    .map((byte) => byte.toString(36))
    .join("");

  // Truncate the ID to the specified maximum length
  return id.slice(0, maxLength);
}
